import routes from './module/routes'
import store from './module/store'
export default {
   name: 'user',
   routes: routes,
   store: store
}